import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Cart, CheckTaxExemptions, Customer, StartCheckout } from '../../../shop';
import { Store } from '@ngrx/store';
import * as navActions from '../../../store/actions/nav.action';

@Component({
    selector: 'app-cart',
    templateUrl: './cart.component.html',
    standalone: false
})
export class CartComponent {
  @Input() cart?: Cart;
  @Input() showList: boolean = false;
  @Input() prefix: string = 'winkelwagen-sidebar';
  @Input() hasVat = false;
  @Input() customer?: any;

  @Input() exemptionsChecked: boolean = false;
  @Input() exemptionsChecking: boolean = false;
  @Input() exemptionsValid: boolean = false;

  @Output() toggleCart = new EventEmitter<void>();
  @Output() closeCart = new EventEmitter<void>();
  @Output() openCart = new EventEmitter<void>();

  get total() {
    return;
  }

  constructor(private store: Store) {}

  toggleList() {
    this.showList = !this.showList;
  }

  closeSidebar() {
    this.store.dispatch(navActions.CloseCart());
  }

  checkout(force: boolean = false) {
    if (this.hasVat && this.customer && !force) {
      this.store.dispatch(CheckTaxExemptions());
      return;
    }
    this.store.dispatch(StartCheckout());
  }
}
